import { useTranslation } from "react-i18next";
import { DiffStatusChip } from "../../DiffStatusChip";
import { KIND_LABEL_KEY } from "../../QuantitiesTab/constants";
import { ALL_STATUSES, KIND_TO_QUANTITY_KIND } from "../constants";
import type { VisualDiffLegendProps } from "./types";

export const VisualDiffLegend = ({
  countsByStatus,
  visibleStatuses,
  kind,
  onStatusToggle,
}: VisualDiffLegendProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className="whitespace-nowrap text-xs font-medium text-gray-500">
        {t(KIND_LABEL_KEY[KIND_TO_QUANTITY_KIND[kind]])}
      </span>
      {ALL_STATUSES.map((status) => (
        <DiffStatusChip
          key={status}
          label={t(`smartSurveyor.planComparison.quantities.${status}`)}
          count={countsByStatus[status]}
          status={status}
          isSelected={visibleStatuses[status]}
          onSelect={() => onStatusToggle(status)}
        />
      ))}
    </div>
  );
};
